{
  "title": "Export Bank Statement",
  "subtitle": "The file takes a few minutes to generate. Please wait and do not close the window.",
  "generatingfile": "Generating file, please wait...",
  "generatedfile": "File generated succesfully",
  "errorgeneratingfile": "Error generating file. Please try again.",
  "fileincomplete": "The file generated is incomplete. Please try again to get the full version."
}
